function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.22 4.625a1 1 0 111.56-1.25l3 4a1 1 0 010 1.25l-3 4a1 1 0 11-1.56-1.25L8.72 8l-2.5-3.375z",
  fill: "#243143"
});

function SvgChevronRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMjE5MTcgNC42MjQ3M0M1Ljg3NDE2IDQuMTkzNDcgNS45NDQwOCAzLjU2NDE4IDYuMzc1MzQgMy4yMTkxN0M2LjgwNjYgMi44NzQxNiA3LjQzNTkgMi45NDQwOCA3Ljc4MDkxIDMuMzc1MzRMMTAuNzgwOSA3LjM3NTM0QzExLjA3MzEgNy43NDA1NiAxMS4wNzMxIDguMjU5NTEgMTAuNzgwOSA4LjYyNDczTDcuNzgwOTEgMTIuNjI0N0M3LjQzNTkgMTMuMDU2IDYuODA2NiAxMy4xMjU5IDYuMzc1MzQgMTIuNzgwOUM1Ljk0NDA4IDEyLjQzNTkgNS44NzQxNiAxMS44MDY2IDYuMjE5MTcgMTEuMzc1M0w4LjcxOTQxIDguMDAwMDRMNi4yMTkxNyA0LjYyNDczWiIgZmlsbD0iIzI0MzE0MyIvPgo8L3N2Zz4K";
export { SvgChevronRight16 as ReactComponent };